import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ShoppingCartIcon, CheckCircle2Icon, ClockIcon } from 'lucide-react';
type PlanKey = 'basic' | 'pro';
export function PricingSection() {
  const [selectedPlan, setSelectedPlan] = useState<PlanKey>('basic');
  const plans = {
    basic: {
      name: 'MegaPack KineEficiente',
      oldPrice: '$49.990',
      price: '$19.990',
      url: 'https://checkout.ebookpoint.shop/cart/59394129592401:1'
    },
    pro: {
      name: 'Kine Eficiente + Megapack PRO Rodilla y Hombros',
      oldPrice: '$69.990',
      price: '$27.990',
      url: 'https://checkout.ebookpoint.shop/cart/59438163034193:1'
    }
  };
  const currentPlan = plans[selectedPlan];
  const [timeLeft, setTimeLeft] = useState(() => {
    const saved = sessionStorage.getItem('kine_countdown_end');
    if (saved) {
      const remaining = Math.max(0, Math.floor((parseInt(saved) - Date.now()) / 1000));
      return remaining;
    }
    const duration = Math.floor(Math.random() * (1800 - 600 + 1)) + 600;
    sessionStorage.setItem('kine_countdown_end', String(Date.now() + duration * 1000));
    return duration;
  });
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  return <section id="compra" className="w-full px-4 py-20 bg-gradient-to-b from-[#1e293b] to-[#0f172a]" data-id="element-75">
      <div className="max-w-4xl mx-auto" data-id="element-76">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-77">
          <h2 className="text-3xl md:text-5xl font-black mb-8 text-center" data-id="element-78">
            Empezá a trabajar con un sistema real
          </h2>

          <div className="bg-gradient-to-br from-yellow-400/20 to-yellow-400/5 border-2 border-yellow-400 p-6 md:p-8 rounded-2xl shadow-2xl shadow-yellow-400/20" data-id="element-79">
            <div className="text-center mb-6" data-id="element-80">
              <div className="inline-flex items-center gap-2 bg-[#ef4444] text-white px-4 py-2 rounded-full font-bold text-sm mb-4" data-id="element-81">
                <ClockIcon className="w-4 h-4" data-id="element-82" />
                OFERTA POR TIEMPO LIMITADO
              </div>

              {/* Countdown Timer */}
              <div className="mb-6" data-id="element-83">
                <p className="text-gray-300 text-sm mb-3" data-id="element-84">
                  Esta oferta expira en:
                </p>
                <div className="flex items-center justify-center gap-2" data-id="element-85">
                  <div className="bg-[#0f172a] border border-[#ef4444] rounded-lg px-3 py-2 min-w-[60px]" data-id="element-86">
                    <p className="text-2xl md:text-3xl font-black text-[#ef4444]" data-id="element-87">
                      {String(hours).padStart(2, '0')}
                    </p>
                    <p className="text-[10px] text-gray-400 uppercase" data-id="element-88">Horas</p>
                  </div>
                  <span className="text-2xl font-black text-[#ef4444]" data-id="element-89">:</span>
                  <div className="bg-[#0f172a] border border-[#ef4444] rounded-lg px-3 py-2 min-w-[60px]" data-id="element-90">
                    <p className="text-2xl md:text-3xl font-black text-[#ef4444]" data-id="element-91">
                      {String(minutes).padStart(2, '0')}
                    </p>
                    <p className="text-[10px] text-gray-400 uppercase" data-id="element-92">Min</p>
                  </div>
                  <span className="text-2xl font-black text-[#ef4444]" data-id="element-93">:</span>
                  <div className="bg-[#0f172a] border border-[#ef4444] rounded-lg px-3 py-2 min-w-[60px]" data-id="element-94">
                    <p className="text-2xl md:text-3xl font-black text-[#ef4444]" data-id="element-95">
                      {String(seconds).padStart(2, '0')}
                    </p>
                    <p className="text-[10px] text-gray-400 uppercase" data-id="element-96">Seg</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Plan Selector */}
            <div className="grid grid-cols-2 gap-3 mb-6" data-id="element-97">
              <button onClick={() => setSelectedPlan('basic')} className={`relative p-4 rounded-xl border-2 transition-all text-left ${selectedPlan === 'basic' ? 'border-yellow-400 bg-yellow-400/10' : 'border-white/20 bg-white/5 hover:border-white/40'}`} data-id="element-98">
                {selectedPlan === 'basic' && <div className="absolute -top-2 -right-2 bg-yellow-400 text-black text-[10px] font-bold px-2 py-0.5 rounded-full" data-id="element-99">
                    ELEGIDO
                  </div>}
                <p className="font-bold text-sm md:text-base text-white mb-1" data-id="element-100">
                  MegaPack KineEficiente
                </p>
                <p className="text-gray-500 line-through text-sm" data-id="element-101">$49.990</p>
                <p className="text-2xl md:text-3xl font-black text-yellow-400" data-id="element-102">
                  $19.990
                </p>
              </button>

              <button onClick={() => setSelectedPlan('pro')} className={`relative p-4 rounded-xl border-2 transition-all text-left ${selectedPlan === 'pro' ? 'border-yellow-400 bg-yellow-400/10' : 'border-white/20 bg-white/5 hover:border-white/40'}`} data-id="element-103">
                {selectedPlan === 'pro' && <div className="absolute -top-2 -right-2 bg-yellow-400 text-black text-[10px] font-bold px-2 py-0.5 rounded-full" data-id="element-104">
                    ELEGIDO
                  </div>}
                <div className="absolute -top-2 left-3 bg-[#ef4444] text-white text-[10px] font-bold px-2 py-0.5 rounded-full" data-id="element-105">
                  MÁS COMPLETO
                </div>
                <p className="font-bold text-sm md:text-base text-white mb-1 mt-1" data-id="element-106">
                  Kine Eficiente + PRO Rodilla y Hombros
                </p>
                <p className="text-gray-500 line-through text-sm" data-id="element-107">$69.990</p>
                <p className="text-2xl md:text-3xl font-black text-yellow-400" data-id="element-108">
                  $27.990
                </p>
              </button>
            </div>

            {/* Selected Plan Details & CTA */}
            <div className="text-center" data-id="element-109">
              <p className="text-sm text-yellow-400 font-semibold mb-4" data-id="element-110">
                ✅ Incluye todos los bonos GRATIS por hoy
              </p>

              <motion.a key={selectedPlan} href={currentPlan.url} target="_blank" rel="noopener noreferrer" whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="inline-flex items-center gap-3 bg-yellow-400/90 text-black px-10 py-5 rounded-xl font-black text-xl md:text-2xl shadow-lg shadow-yellow-400/40 hover:shadow-yellow-400/60 transition-shadow" data-id="element-111">
                <ShoppingCartIcon className="w-7 h-7" data-id="element-112" />
                COMPRAR AHORA
              </motion.a>

              <p className="text-sm text-gray-400 mt-4" data-id="element-113">
                🔒 Pago seguro • Acceso instantáneo • Garantía de satisfacción
              </p>
            </div>

            <div className="border-t border-yellow-400/30 pt-4 mt-6" data-id="element-114">
              <p className="text-center text-gray-300 text-sm" data-id="element-115">
                Al hacer clic en "COMPRAR AHORA" serás redirigido a la página de
                pago seguro
              </p>
            </div>
          </div>

          <div className="mt-6 bg-yellow-400/10 border-2 border-yellow-400 p-5 rounded-xl text-center" data-id="element-116">
            <p className="text-xl font-black text-yellow-400 mb-1" data-id="element-117">
              🎁 Comprando HOY llevate también el pack{' '}
              <span className="bg-yellow-400/20 text-yellow-300 px-2 py-0.5 rounded border border-yellow-400/30" data-id="element-118">
                "KinesioTaping PRO"
              </span>{' '}
              y{' '}
              <span className="bg-white/10 text-white px-2 py-0.5 rounded border border-white/20" data-id="element-119">
                "Anatomía Sin Estrés"
              </span>
            </p>
            <p className="text-gray-300 text-sm mt-2" data-id="element-120">
              Incluido sin costo adicional solo por tiempo limitado
            </p>
          </div>

          <div className="mt-4 bg-[#f97316]/20 border border-[#f97316] p-5 rounded-lg text-center" data-id="element-121">
            <p className="text-xl font-bold text-[#f97316]" data-id="element-122">
              ⚡ Esta oferta puede terminar en cualquier momento
            </p>
            <p className="text-gray-300 mt-1 text-sm" data-id="element-123">
              No pierdas la oportunidad de transformar tu práctica clínica hoy
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}